import React from 'react';
export default function SocialIcons(_ref) {
  var social = _ref.social;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "social-icons-wrapper footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "social-icons"
  }, social.map(function (pref, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "social-item",
      key: index
    }, /*#__PURE__*/React.createElement("a", {
      className: "fa-brands fa-".concat(pref.social == 'twitter' ? 'x-twitter' : pref.social),
      href: pref.url,
      target: "_blank"
    }), /*#__PURE__*/React.createElement("div", {
      className: "social-icon-text"
    }, pref.social));
  }))));
}